import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import {
  GET_VOCABULARY,
} from "../actions";

import {
  getVocabularySuccess,
  getVocabularyError
} from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

export function* watchGetVocabulary() {
  yield takeEvery(GET_VOCABULARY, getVocabulary);
}

const getVocabularyAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get(
      `/vocabularies/${payload.vocabularyId}`, getActivityHeadersUpdated(payload)
    );
    if (dataReturned.data) {
      return {
        vocabulary: dataReturned.data,
        message: null,
      };
    }
    return { message: "Get vocabulary failed." };
  } catch (error) {
    return {
      message: "Failed to get vocabularyId.",
    };
  }
};

function* getVocabulary({ payload }) {

  try {
    const returnedData = yield call(getVocabularyAsync, payload);
    if (!returnedData.message) {
      yield put(
        getVocabularySuccess({
          vocabulary: returnedData.vocabulary,
        })
      );
    } else {
      yield put(getVocabularyError(returnedData.message));
    }
  } catch (error) {
    yield put(getVocabularyError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetVocabulary)
  ]);
}
